import { commonLang } from '@umu/ukit-lang';
import React, { Component } from 'react';
import { isSame } from '@umu/umu-util';
import { $location } from '@umu/umu-dom';
import { components, services } from 'common';
const { If } = components;
const { Toast } = services;
import { toogleFllowTeacher } from '@umu/umu-api';

import UserAvatar from '../user/userAvatar/userAvatar';
import { UmuUserName } from '../user/umuUserName';
import { Tag } from '@umu/umu-design';

import showQuickRegisterDialog from '../account/@quickRegisterDialog/quickRegisterDialog';
import wechatServiceAccount from '../../services/@wechatServiceAccount/wechatServiceAccount';
import {
    WrapperUseMobileIframeLandscapeDisplayManager,
    IWrapperUseMobileIframeLandscapeDisplayProps,
} from '../../services/responsiveDisplay/course';
import './teacherInfo.scss';

import { ICreatorInfo, IUserInfo } from '@umu/umu-types';
import { isFromCourseMiniApp } from '../../@utils/umuUtil';
interface ITeacherInfo extends ICreatorInfo {
    certification_status?: number;
}
interface ITeacherProps extends IWrapperUseMobileIframeLandscapeDisplayProps {
    teacherInfo: ITeacherInfo;
    userInfo: IUserInfo;
    fllowText?: string;
    isFollowTeacher?: boolean;
    showUserRole?: boolean;
    teacherFollowerCount?: number;
    fllowTeacherHandler?: () => void;
}

interface IState {
    teacherFollowerCount: number;
    isFollowTeacher: boolean;
    isDisplayInIframeLandscape: boolean;
}

class TeacherInfo extends Component<ITeacherProps, IState> {
    public static defaultProps = {
        userInfo: {},
    };

    constructor(props: ITeacherProps) {
        super(props);
        this.goToHome = this.goToHome.bind(this);
        this.state = {
            teacherFollowerCount: Number(props.teacherFollowerCount) || props.teacherInfo.follower_count || 0,
            isFollowTeacher: props.isFollowTeacher || false,
            isDisplayInIframeLandscape: false,
        };
    }
    public render() {
        const { teacherInfo, showUserRole, userInfo, fllowText: fllowTextProps } = this.props;
        const { teacherFollowerCount, isFollowTeacher } = this.state;
        const fllowText = fllowTextProps || commonLang('{$0{0= 位关注者,1= 位关注者}}', teacherFollowerCount);
        const avatar = this.getTeacherAvatar();
        const isLecturer = teacherInfo.certification_status;
        return (
            <div className="teacher-info-box clearfix">
                <div className="teacher-info" onClick={this.goToHome}>
                    <div className="teacher-avatar">
                        <UserAvatar
                            src={avatar}
                            className="teacher-avatar"
                            width={40}
                            showUserLevel={teacherInfo.show_user_level}
                            userLevelInfo={teacherInfo.user_level}
                        />
                    </div>
                    <div className="teacher-wrapper">
                        <div className="wrap-top flex--start--center">
                            <div className="user-name flex--1">
                                <UmuUserName
                                    className="data-user-name"
                                    name={teacherInfo.user_name || commonLang('未登录用户')}
                                    userMedalInfo={teacherInfo.user_medal}
                                    showUserLevel={teacherInfo.show_user_level}
                                    userLable={(showUserRole && Number(teacherInfo.teacher_id) > 0) ? commonLang('讲师') : ''}
                                />
                            </div>
                            {showUserRole && isLecturer ? (
                                <div className="user-name-role-holder">
                                    <Tag color="blue">{commonLang('认证讲师')}</Tag>
                                </div>
                            ) : null}
                        </div>
                        <div className="wrap-bottom">{fllowText}</div>
                    </div>
                </div>
                <If condition={!isSame(teacherInfo.umu_id, userInfo.umu_id)}>
                    <div className="teacher-fllow">
                        <button
                            className={`btn-mind ${isFollowTeacher ? 'followed' : ''}`}
                            onClick={this.onFollow.bind(this)}
                        >
                            {isFollowTeacher ? commonLang('已关注') : commonLang('关注')}
                        </button>
                    </div>
                </If>
            </div>
        );
    }

    /**
     * getTeacherAvatar
     */
    public getTeacherAvatar() {
        const { teacherInfo } = this.props;
        return teacherInfo.avatar;
    }

    /**
     * goToHome
     * 跳转到老师个人主页
     */
    public goToHome() {
        if (isFromCourseMiniApp()) {
            return;
        }
        const {
            teacherInfo: { home_url: homeUrl },
            _isDisplayInIframeModeForCourse,
        } = this.props;
        if (homeUrl) {
            if (_isDisplayInIframeModeForCourse) {
                window.open(homeUrl, '_blank');
            } else {
                $location.href = homeUrl;
            }
        }
    }

    private onFollow = () => {
        const props = this.props;
        const state = this.state;
        const { student_id: studentId } = this.props.userInfo;
        // todo: 未注册用户引导注册
        if (!studentId) {
            showQuickRegisterDialog({
                dialogType: 'FOLLOW',
            });
            return;
        }
        const data = {
            is_follow: state.isFollowTeacher ? 0 : 1,
            famous_id: props.teacherInfo.teacher_id,
        };
        toogleFllowTeacher(data).then(() => {
            const isFollow = !state.isFollowTeacher;
            let followCount = state.teacherFollowerCount;
            if (isFollow) {
                followCount += 1;
            } else {
                followCount -= 1;
            }

            if (isFollow) {
                if (!wechatServiceAccount.checkFollowUmu()) {
                    wechatServiceAccount.follow();
                } else {
                    Toast.show({
                        message: commonLang('关注成功'),
                    });
                }
            }

            const followResult = {
                isFollowTeacher: isFollow,
                teacherFollowerCount: followCount,
            };
            this.setState(followResult);
            if (this.props.fllowTeacherHandler) {
                this.props.fllowTeacherHandler();
            }
        });
    };
}

export default WrapperUseMobileIframeLandscapeDisplayManager(TeacherInfo);
